import React from 'react';
import loadable from '@loadable/component';

import withPageComponents from '../../../page/components/with-page-components';
import { Helpers } from '../../../core/src/helpers';
import useCartState from '../../../hooks/useCartState';

import './index.less';

const ProductRecommendations = loadable(() =>
    Helpers.retryFunc(() => import('../../../product/components/personalized-product-carousel/visid')),
);

/***
 * Product Recommendations for cart
 * @param vanityUrl
 * @param {(crossSell|emptyCart)} variation
 */
export default withPageComponents(
    ({ variation = 'crossSell', cartSettings, PlaceHolder, onRecsReceived }) => {
        const { personalization } = cartSettings || {};
        const {
            productRecStrategyId = 427205,
            emptyCartStrategyId = 432321,
            title: productRecTitle = 'Specialty Accessories',
            emtpyCartTitle = 'Recently Viewed',
            enabledVariations = ['emptyCart'],
        } = personalization || {};
        const { cartInfo } = useCartState();
        const { cartView } = cartInfo || {};
        const { orderItem } = cartView || {};
        const title = variation === 'emptyCart' ? emtpyCartTitle : productRecTitle;

        if ((!orderItem && variation !== 'emptyCart') || !enabledVariations.includes(variation)) return null;

        const skulist = (orderItem || []).map(({ partNumber }) => partNumber);
        const strategyId = variation === 'emptyCart' ? emptyCartStrategyId : productRecStrategyId;
        const dyName = variation === 'emptyCart' ? 'Empty Cart Recommendations' : 'Cart Cross-Sell Recommendations';
        return (
            <ProductRecommendations
                className={variation}
                skulist={skulist}
                strategyId={strategyId}
                title={title}
                PlaceHolder={PlaceHolder}
                onRecsReceived={onRecsReceived}
                componentKey={`cart-${variation === 'emptyCart' ? 'empty-cart-recommendations' : 'specialty-accessories'}`}
                dyName={dyName}
                list="cart"
            />
        );
    },
    { components: ['cartSettings'] },
);
